import { educationalLevel } from '@/api/common/master-lists'

export default {
  namespaced: true,
  state () {
    return {
      loading: false,
      items: sessionStorage.getItem('educationalLevels')
        ? JSON.parse(sessionStorage.getItem('educationalLevels'))
        : []
    }
  },
  getters: {
    hasItems: state => {
      return state.items.length > 0
    }
  },
  mutations: {
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    setItems (state, items) {
      state.items = items
    },
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    setLoading (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Soft Fetch
     * If items is already populated skip the process
     *
     * @param { getters, dispatch}
     */
    softFetch ({ getters, dispatch }) {
      if (getters.hasItems) return
      dispatch('fetch')
    },

    /**
     * Fetch Items
     *
     * @param {commit, dispatch} object
     */
    fetch ({ commit, dispatch }) {
      commit('setLoading', true)

      educationalLevel.index()
        .then(({ data }) => {
          commit('setItems', data)

          sessionStorage.setItem('educationalLevels', JSON.stringify(data))
        })
        .catch(({ response }) => {
          dispatch('httpException/handle', response, { root: true })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  }
}
